/**
 * Java 代码生成器
 * 生成使用 HttpURLConnection 的 Java HTTP 请求代码
 */

import { BaseCodeGenerator } from './base.js';

export class JavaGenerator extends BaseCodeGenerator {
  constructor() {
    super({
      language: 'java',
      library: 'HttpURLConnection',
      indent: '    ',
      maxLineLength: 80
    });
  }

  generate(parsedCurl) {
    this.validateParsedCurl(parsedCurl);

    const lines = [];
    lines.push('import java.net.HttpURLConnection;');
    lines.push('import java.net.URL;');
    lines.push('import java.io.BufferedReader;');
    lines.push('import java.io.InputStreamReader;');
    lines.push('import java.io.OutputStream;');
    lines.push('');
    lines.push('public class HttpRequest {');
    lines.push('    public static void main(String[] args) {');
    lines.push('        try {');
    lines.push(`            ${this.generateComment(`发送 ${parsedCurl.method} 请求到 ${parsedCurl.url}`)}`);
    lines.push(`            URL url = new URL("${this.escapeString(parsedCurl.url)}");`);
    lines.push('            HttpURLConnection conn = (HttpURLConnection) url.openConnection();');
    lines.push(`            conn.setRequestMethod("${parsedCurl.method}");`);
    
    if (Object.keys(parsedCurl.headers).length > 0) {
      lines.push('');
      Object.entries(parsedCurl.headers).forEach(([key, value]) => {
        lines.push(`            conn.setRequestProperty("${this.escapeString(key)}", "${this.escapeString(value)}");`);
      });
    }

    if (parsedCurl.data.type !== 'none') {
      lines.push('');
      lines.push('            conn.setDoOutput(true);');
      lines.push(`            String data = "${this.escapeString(parsedCurl.data.content)}";`);
      lines.push('            try (OutputStream os = conn.getOutputStream()) {');
      lines.push('                byte[] input = data.getBytes("utf-8");');
      lines.push('                os.write(input, 0, input.length);');
      lines.push('            }');
    }

    lines.push('');
    lines.push('            int responseCode = conn.getResponseCode();');
    lines.push('            System.out.println("Response Code: " + responseCode);');
    lines.push('');
    lines.push('            BufferedReader reader = new BufferedReader(');
    lines.push('                new InputStreamReader(conn.getInputStream()));');
    lines.push('            String line;');
    lines.push('            StringBuilder response = new StringBuilder();');
    lines.push('            while ((line = reader.readLine()) != null) {');
    lines.push('                response.append(line);');
    lines.push('            }');
    lines.push('            reader.close();');
    lines.push('');
    lines.push('            System.out.println(response.toString());');
    lines.push('        } catch (Exception e) {');
    lines.push('            e.printStackTrace();');
    lines.push('        }');
    lines.push('    }');
    lines.push('}');

    return lines.join('\n');
  }

  generateComment(text) {
    return `// ${text}`;
  }

  escapeString(str) {
    return str
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/\t/g, '\\t');
  }
}